import { Debounce, deepCopy, getShortId } from '@nyanyajs/utils'
import { alert } from '@saki-ui/core'
import { CSSProperties, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { bindEvent } from '../modules/bindEvent'
import store, { AppDispatch, methods, notesSlice, RootState } from '../store'
import './AsideContent.scss'

import moment from 'moment'
import { protoRoot } from '../protos'
import { configSlice, eventListener, initialConfigState } from '../store/config'
import { ContentResult, getContent } from '../store/notes/methods'
import { getDefaultLabels, getSubTodoCount } from '../store/notes/todolist'

import { catalogSlice, getCatalogEl } from '../store/catalog'
import HistoricalVersionPage from './HistoricalVersion'
import {
  SakiBreadcrumb,
  SakiButton,
  SakiCheckbox,
  SakiCheckboxItem,
  SakiIcon,
  SakiInput,
  SakiMenuItem,
  SakiRow,
  SakiTitle,
} from './saki-ui-react/components'
import { BreadcrumbOptionItem } from './saki-ui-react/types/components/Breadcrumb/breadcrumb'
import { ImportanceDropdownComponent } from './TodoListContentPage'

const AsideContentComponent = () => {
  const { t, i18n } = useTranslation('asideContentModal')
  const dispatch = useDispatch<AppDispatch>()
  const notes = useSelector((state: RootState) => state.notes)
  const config = useSelector((state: RootState) => state.config)

  const asideContentModal = useSelector(
    (state: RootState) => state.config.pageConfig.asideContentModal
  )

  const headerPosition =
    asideContentModal.data.type === 'HistoricalVersion' ||
    asideContentModal.data.type === 'SetLabels'
      ? 'Top'
      : 'Bottom'

  let history = useNavigate()
  const ref = useRef<any>(null)

  const [contentResult, setContentResult] = useState<ContentResult>()
  const [todo, setTodo] = useState<protoRoot.note.ITodoListPageItem>()
  const [page, setPage] = useState<protoRoot.note.IPageItem>()

  // console.log('SetLabels headerPosition', asideContentModal.data.type, page)
  useEffect(() => {
    const { noteId, categoryId, pageId, todoId, type } = asideContentModal.data
    if (noteId) {
      const contentResult = getContent({
        noteId,
        categoryId,
        pageId,
      })
      setContentResult(contentResult)
      if (type === 'Todo' || type === 'MoveTaskTo') {
        contentResult.todoList?.some((v) => {
          if (v.id === asideContentModal.data.todoId) {
            setTodo(v)
            return true
          }
        })
      }
      if (type === 'Catalog' || type === 'SetLabels') {
        setPage(contentResult.page)
      }
    }
  }, [asideContentModal, notes])

  const mainEl = useRef<HTMLDivElement>()

  const drag = useRef(false)
  const dragStartTime = useRef(0)

  const [tempWidth, setTempWidth] = useState(0)
  const [confirmButtonDisabled, setConfirmButtonDisabled] = useState(true)

  const d = useRef(new Debounce())

  useEffect(() => {
    d.current.increase(() => {
      eventListener.on('confirmButtonDisabled', (val) => {
        setConfirmButtonDisabled(val)
      })

      let startX = 0
      let moveX = 0
      let tempWidth = 0
      window.addEventListener('mousemove', (e) => {
        if (drag.current) {
          if (!startX) {
            startX = e.pageX
          }
          moveX = e.pageX - startX

          const { config } = store.getState()

          tempWidth = config.pageConfig.asideContentModal.width + moveX

          if (
            config.pageConfig.asideContentModal.width + moveX >
            window.innerWidth - 100
          ) {
            tempWidth = window.innerWidth - 100
          }
          if (config.pageConfig.asideContentModal.width + moveX <= 200) {
            tempWidth = 200
          }
          setTempWidth(tempWidth)
        }
      })
      window.addEventListener('mouseup', () => {
        // console.log('mouseup', moveX)
        setDrag(false, tempWidth)
        startX = 0
        moveX = 0
        tempWidth = 0
      })
    }, 100)
  }, [])

  useEffect(() => {
    if (drag.current) {
      document.body.style.userSelect = 'none'
      return
    }
    document.body.style.userSelect = ''
  }, [drag.current])

  const setDrag = (b: boolean, tempWidth?: number) => {
    drag.current = b

    if (drag.current) {
      document.body.style.userSelect = 'none'
      return
    }
    document.body.style.userSelect = ''
    setTempWidth(0)

    if (tempWidth) {
      dispatch(configSlice.actions.setAsideContentModalWidth(tempWidth))
    }
  }

  return (
    <saki-aside-modal
      ref={bindEvent({
        close: () => {
          dispatch(
            configSlice.actions.setShowAsideContentModal({
              visible: false,
            })
          )
        },
      })}
      vertical="Bottom"
      horizontal="Left"
      visible={asideContentModal.visible}
      width={
        config.deviceType === 'Mobile'
          ? '100%'
          : (asideContentModal.data.type === 'Catalog'
              ? config.pageConfig.asideContentModal.width
              : config.pageConfig.asideContentModal.width) + 'px'
      }
      height={
        config.deviceType === 'Mobile'
          ? 'calc(100% - 100px)'
          : 'calc(100% - 50px)'
      }
      background-color="#fff"
      border-radius={config.deviceType === 'Mobile' ? '0px' : '0px'}
      box-shadow="0px 1.2px 3.6px rgba(0,0,0,0.1),0px 6.4px 14.4px rgba(0,0,0,0.1)"
      // border='1px solid #eee'
      offset-x="0px"
      offset-y="0px"
      mask={config.deviceType === 'Mobile'}
      mask-closable={config.deviceType === 'Mobile'}
      overflow="visible"
      z-index="899"
    >
      <div className={'aside-content-component ' + asideContentModal.data.type}>
        {/* <saki-scroll-view mode='Auto'>
				</saki-scroll-view> */}

        <div
          className={
            'ac-main ' +
            (asideContentModal.data.type !== 'MoveTaskTo'
              ? 'scrollBarHover'
              : '')
          }
        >
          {asideContentModal.visible &&
          asideContentModal.data.type === 'HistoricalVersion' &&
          contentResult ? (
            <>
              <HistoricalVersionPage
                contentResult={contentResult}
              ></HistoricalVersionPage>
            </>
          ) : (
            ''
          )}
          {asideContentModal.visible &&
          asideContentModal.data.type === 'Catalog' &&
          contentResult &&
          page ? (
            <>
              <CatalogPage
                contentResult={contentResult}
                page={page}
              ></CatalogPage>
            </>
          ) : (
            ''
          )}
          {asideContentModal.visible &&
          asideContentModal.data.type === 'Todo' &&
          contentResult &&
          todo ? (
            <>
              <TodoSidePage
                contentResult={contentResult}
                todo={todo}
              ></TodoSidePage>
            </>
          ) : (
            ''
          )}
          {asideContentModal.visible &&
          asideContentModal.data.type === 'MoveTaskTo' &&
          contentResult &&
          todo ? (
            <>
              <MoveTaskToPage
                contentResult={contentResult}
                todo={todo}
              ></MoveTaskToPage>
            </>
          ) : (
            ''
          )}
          {asideContentModal.visible &&
          asideContentModal.data.type === 'SetLabels' &&
          contentResult ? (
            <>
              <SetLabelsPage contentResult={contentResult}></SetLabelsPage>
            </>
          ) : (
            ''
          )}
        </div>
        <div className="ac-buttons">
          <SakiRow alignItems="center" class="ac-b-left">
            {headerPosition === 'Top' ? (
              <SakiButton
                onTap={() => {
                  dispatch(
                    configSlice.actions.setShowAsideContentModal({
                      visible: false,
                    })
                  )
                }}
                margin="0 0 0 4px"
                width="40px"
                height="40px"
                bg-color="transparent"
                type="CircleIconGrayHover"
                className="close-button"
              >
                <saki-icon
                  width="18px"
                  height="18px"
                  color="#666"
                  type={'Close'}
                ></saki-icon>
              </SakiButton>
            ) : (
              <SakiButton
                onTap={async () => {
                  const { noteId, categoryId, pageId, type, todoId } =
                    asideContentModal.data
                  if (type === 'Todo' && todoId) {
                    await dispatch(
                      methods.notes.DeleteTodo({
                        noteId,
                        categoryId,
                        pageId,
                        todoId,
                      })
                    ).unwrap()
                  }
                  if (type === 'Catalog' && page) {
                    alert({
                      title: t('delete', {
                        ns: 'common',
                      }),
                      content: t('deleteThisPage', {
                        ns: 'common',
                      }),
                      cancelText: t('cancel', {
                        ns: 'common',
                      }),
                      confirmText: t('delete', {
                        ns: 'common',
                      }),
                      onCancel() {},
                      async onConfirm() {
                        dispatch(
                          configSlice.actions.setDisableChangeValue(true)
                        )
                        dispatch(
                          notesSlice.actions.deletePage({
                            noteId: noteId,
                            categoryId: categoryId,
                            pageId: page?.id || '',
                          })
                        )
                      },
                    }).open()
                  }
                }}
                margin="0 0 0 4px"
                width="40px"
                height="40px"
                bg-color="transparent"
                type="CircleIconGrayHover"
                className="delete-button"
              >
                <saki-icon
                  width="18px"
                  height="18px"
                  color="#666"
                  type="Trash"
                ></saki-icon>
              </SakiButton>
            )}
          </SakiRow>
          {headerPosition === 'Top' ? (
            <SakiTitle level={3}>
              {asideContentModal.data.type === 'HistoricalVersion' ? (
                <span>
                  {t('pageTitle', {
                    ns: 'historicalVersionPage',
                  })}
                </span>
              ) : asideContentModal.data.type === 'SetLabels' ? (
                <span>
                  {`${t('setLabel', {
                    ns: 'todoPage',
                  })} [${page?.title}]`}
                </span>
              ) : (
                ''
              )}
            </SakiTitle>
          ) : (
            <span
              style={{
                color: '#666',
                fontSize: '12px',
              }}
            >
              {t('createdOn', {
                ns: 'todoPage',
                time: moment(
                  Number(
                    asideContentModal.data.type !== 'Catalog'
                      ? todo?.createTime || 0
                      : page?.createTime || 0
                  ) * 1000
                ).calendar({
                  sameDay: '[Today] HH:mm',
                  nextDay: '[Tomorrow] HH:mm',
                  nextWeek: 'dddd',
                  lastDay: '[Yesterday] HH:mm',
                  lastWeek: 'YYYY-MM-DD HH:mm',
                  sameElse: 'YYYY-MM-DD HH:mm',
                }),
              })}
            </span>
          )}

          <SakiRow alignItems="center" class="ac-b-right">
            {headerPosition === 'Top' ? (
              asideContentModal.data.type === 'HistoricalVersion' ? (
                <saki-button
                  ref={bindEvent({
                    tap: () => {
                      eventListener.dispatch('restoreButtonClick', undefined)
                    },
                  })}
                  type="Primary"
                  disabled={confirmButtonDisabled}
                >
                  <span>
                    {t('restore', {
                      ns: 'common',
                    })}
                  </span>
                </saki-button>
              ) : asideContentModal.data.type === 'SetLabels' ? (
                <saki-button
                  ref={bindEvent({
                    tap: () => {
                      eventListener.dispatch('saveButtonClick', undefined)
                    },
                  })}
                  type="Primary"
                  disabled={confirmButtonDisabled}
                >
                  <span>
                    {t('save', {
                      ns: 'common',
                    })}
                  </span>
                </saki-button>
              ) : (
                ''
              )
            ) : (
              <SakiButton
                onTap={() => {
                  dispatch(
                    configSlice.actions.setShowAsideContentModal({
                      visible: false,
                    })
                  )
                }}
                margin="0 0 0 4px"
                width="40px"
                height="40px"
                bg-color="transparent"
                type="CircleIconGrayHover"
                className="close-button"
              >
                <saki-icon
                  width="18px"
                  height="18px"
                  color="#666"
                  type="CloseAside"
                ></saki-icon>
              </SakiButton>
            )}
          </SakiRow>
        </div>
        <div
          style={{
            height:
              config.deviceType === 'Mobile'
                ? 'calc(100% - 100px)'
                : 'calc(100% - 50px)',
            left:
              (tempWidth || config.pageConfig.asideContentModal.width) + 'px',
          }}
          ref={
            bindEvent({
              mousedown: () => {
                setDrag(true)

                if (
                  dragStartTime.current &&
                  new Date().getTime() - dragStartTime.current < 700
                ) {
                  dispatch(
                    configSlice.actions.setAsideContentModalWidth(
                      initialConfigState.pageConfig.asideContentModal.width
                    )
                  )
                  dragStartTime.current = 0
                  return
                }
                dragStartTime.current = new Date().getTime()
              },
            }) as any
          }
          className={'ac-drag ' + (tempWidth ? 'drag' : '')}
        ></div>
      </div>
    </saki-aside-modal>
  )
}

const CatalogPage = ({
  page,
  contentResult,
}: {
  contentResult: ContentResult
  page: protoRoot.note.IPageItem
}) => {
  const { t, i18n } = useTranslation('indexPage')

  const d = useRef(new Debounce())
  const scrollToDeb = useRef(new Debounce())
  const dispatch = useDispatch<AppDispatch>()

  const config = useSelector((state: RootState) => state.config)
  const notes = useSelector((state: RootState) => state.notes)
  const catalog = useSelector((state: RootState) => state.catalog)
  const autoCloseWindowAfterCopy = useSelector(
    (state: RootState) => state.config.general.autoCloseWindowAfterCopy
  )

  const asideContentModal = useSelector(
    (state: RootState) => state.config.pageConfig.asideContentModal
  )

  const [breadcrumbOptions, setBreadcrumbOptions] = useState<
    BreadcrumbOptionItem[]
  >([])

  useEffect(() => {
    catalog.clickCatalogId.id &&
      d.current.increase(() => {
        if (
          catalog.clickCatalogId.id &&
          catalog.clickCatalogId.time < new Date().getTime()
        ) {
          dispatch(
            catalogSlice.actions.setClickCatalogId({
              id: undefined,
              time: 0,
            })
          )
        }
      }, 100)
  }, [catalog.activeCatalogId, catalog.clickCatalogId.id])

  useEffect(() => {
    if (
      asideContentModal.visible &&
      asideContentModal.data?.type === 'Catalog'
    ) {
      const breadcrumbOptions: BreadcrumbOptionItem[] = []
      if (contentResult.note) {
        breadcrumbOptions.push({
          value: contentResult.note.id || '',
          text: contentResult.note.name || '',
        })
      }
      if (contentResult.category) {
        breadcrumbOptions.push({
          value: contentResult.category.id || '',
          text: contentResult.category.name || '',
        })
      }
      if (contentResult.page) {
        breadcrumbOptions.push({
          value: contentResult.page.id || '',
          text:
            contentResult?.page?.title ||
            t('untitledPage', {
              ns: 'indexPage',
            }),
        })
      }

      setBreadcrumbOptions(breadcrumbOptions)
    }
    return () => {}
  }, [asideContentModal.visible])

  const scrollTo = (e: HTMLElement) => {
    scrollToDeb.current.increase(() => {
      const mainEl = document.body.querySelector('.ac-main')
      if (!mainEl) return
      const eRect = e.getBoundingClientRect()
      const cpListElRect = mainEl.getBoundingClientRect()
      mainEl.scrollTop = mainEl.scrollTop + (eRect.top - cpListElRect.top) - 100
    }, 100)
  }

  return (
    <div className="catalog-page">
      {breadcrumbOptions?.length ? (
        <SakiBreadcrumb
          padding="0 20px"
          options={breadcrumbOptions}
        ></SakiBreadcrumb>
      ) : (
        ''
      )}
      <div className="cp-list">
        {catalog.catalogs.map((v, i) => {
          const active = catalog.clickCatalogId.id
            ? catalog.clickCatalogId.id === v.id
            : v.id === catalog.activeCatalogId.id
          return (
            <div
              ref={
                bindEvent(
                  {
                    click: () => {
                      const editorContentEl =
                        document.querySelector('.ql-editor')
                      if (!editorContentEl) {
                        return
                      }
                      const hEl = getCatalogEl(v.id)
                      const editorContentElRect =
                        editorContentEl?.getBoundingClientRect()
                      const hElRect = hEl.getBoundingClientRect()

                      editorContentEl.scrollTop =
                        editorContentEl.scrollTop +
                        (hElRect.top - editorContentElRect.top)
                      dispatch(
                        catalogSlice.actions.setClickCatalogId({
                          id: v.id,
                          time: new Date().getTime() + 1 * 1000,
                        })
                      )

                      if (config.deviceType === 'Mobile') {
                        dispatch(
                          configSlice.actions.setShowAsideContentModal({
                            visible: false,
                          })
                        )
                      }
                    },
                  },
                  (e) => {
                    if (!active || !e) return
                    scrollTo(e)
                  }
                ) as any
              }
              style={{
                ...({
                  '--catalog-left': (v.level - 1) * 10 + 'px',
                } as any),
              }}
              className={'cp-l-item ' + (active ? 'active' : '')}
              key={i}
            >
              <span>{v.index}</span>
              <span>{v.title}</span>
            </div>
          )
        })}
      </div>
    </div>
  )
}

const TodoSidePage = ({
  contentResult,
  todo,
}: {
  contentResult: ContentResult
  todo: protoRoot.note.ITodoListPageItem
}) => {
  const { t, i18n } = useTranslation('todoPage')

  const d = useRef(new Debounce())
  const dispatch = useDispatch<AppDispatch>()

  const notes = useSelector((state: RootState) => state.notes)
  const config = useSelector((state: RootState) => state.config)
  const autoCloseWindowAfterCopy = useSelector(
    (state: RootState) => state.config.general.autoCloseWindowAfterCopy
  )

  const asideContentModal = useSelector(
    (state: RootState) => state.config.pageConfig.asideContentModal
  )

  let history = useNavigate()
  const ref = useRef<any>(null)

  const richtextEl = useRef<any>()

  const [title, setTitle] = useState('')
  const [note, setNote] = useState('')

  const typingTitle = useRef(false)
  const typingNote = useRef(false)
  // const [typingTitle, setTypingTitle] = useState(false)
  // const [typingNote, setTypingNote] = useState(false)

  const [breadcrumbOptions, setBreadcrumbOptions] = useState<
    BreadcrumbOptionItem[]
  >([])

  useEffect(() => {
    if (typingTitle.current) {
      return
    }
    // console.log('typingTitle title')
    if (todo?.id) {
      setTitle(todo?.title?.toString() || '')

      return
    }
    setTitle('')
  }, [todo?.id, todo?.title])
  useEffect(() => {
    if (typingNote.current) {
      return
    }
    if (todo?.id) {
      setNote(todo?.note || '')
      richtextEl.current?.setValue(todo?.note || '')
      return
    }
    setNote('')
  }, [todo?.id, todo?.note])

  useEffect(() => {
    if (asideContentModal.visible && asideContentModal.data?.type === 'Todo') {
      const breadcrumbOptions: BreadcrumbOptionItem[] = []
      if (contentResult.note) {
        breadcrumbOptions.push({
          value: contentResult.note.id || '',
          text: contentResult.note.name || '',
        })
      }
      if (contentResult.category) {
        breadcrumbOptions.push({
          value: contentResult.category.id || '',
          text: contentResult.category.name || '',
        })
      }
      if (contentResult.page) {
        breadcrumbOptions.push({
          value: contentResult.page.id || '',
          text:
            contentResult?.page?.title ||
            t('untitledPage', {
              ns: 'indexPage',
            }),
        })
      }
      if (todo) {
        breadcrumbOptions.push({
          value: todo.id || '',
          text: 'ID: ' + todo.id,
        })
      }

      setBreadcrumbOptions(breadcrumbOptions)
    }
    return () => {}
  }, [asideContentModal.visible])

  useEffect(() => {
    // console.log('datadata111111111111111', todo?.note, 1, note)
    d.current.increase(async () => {
      // console.log(
      // 	'datadata',
      // 	todo.title,
      // 	1,
      // 	todo.note,
      // 	2,
      // 	title,
      // 	3,
      // 	note,
      // 	4,
      // 	todo?.title !== title,
      // 	todo?.note !== note
      // )
      if (todo?.title !== title || todo?.note !== note) {
        const { noteId, categoryId, pageId } = asideContentModal.data
        dispatch(
          notesSlice.actions.updateTodo({
            noteId,
            categoryId,
            pageId,
            todoId: todo.id || '',
            data: {
              ...(todo?.title === title
                ? {}
                : {
                    title,
                  }),
              ...(todo?.note === note
                ? {}
                : {
                    note,
                  }),
            },
          })
        )
      }
    }, 700)
  }, [title, note])

  return (
    <div className="todo-side-page">
      {breadcrumbOptions?.length ? (
        <SakiBreadcrumb options={breadcrumbOptions}></SakiBreadcrumb>
      ) : (
        ''
      )}
      <div className="ts-title">
        <saki-checkbox
          ref={bindEvent({
            selectvalue(e) {
              console.log(e.detail)
              const { noteId, categoryId, pageId } = asideContentModal.data
              dispatch(
                notesSlice.actions.updateTodo({
                  noteId,
                  categoryId,
                  pageId,
                  todoId: e.detail.value,
                  data: {
                    status: e.detail.values.includes(e.detail.value) ? 1 : 0,
                  },
                })
              )
            },
          })}
          value={[todo.status === 1 ? todo.id || '' : '']}
          flex-direction="Column"
          type="Checkbox"
        >
          <saki-checkbox-item
            margin="16px 8px 0px 0"
            value={todo?.id || ''}
            // border-radius='50%'
            padding="4px"
            icon-size="10px"
          ></saki-checkbox-item>
        </saki-checkbox>
        <saki-input
          ref={bindEvent({
            changevalue: (e) => {
              setTitle(e.detail || '')
            },
            focusfunc: () => {
              // setTypingTitle(true)
              typingTitle.current = true
            },
            blurfunc: () => {
              // setTypingTitle(false)
              typingTitle.current = false
              // if (!title) {
              //   setTitle(todo?.title || '')
              //   return
              // }
            },
          })}
          width="100%"
          height="50px"
          font-size="14px"
          value={title}
          placeholder={t('addTask', {
            ns: 'todoPage',
          })}
          placeholder-animation="MoveUp"
        />
      </div>
      <div className="ts-importance">
        <span>
          {t('importance', {
            ns: 'todoPage',
          })}
        </span>

        <ImportanceDropdownComponent
          noteId={asideContentModal.data?.noteId}
          categoryId={asideContentModal.data?.categoryId}
          pageId={asideContentModal.data?.pageId}
          todo={todo}
        />
      </div>
      <div className="ts-note">
        <saki-richtext
          ref={bindEvent(
            {
              changevalue: (e) => {
                // console.log('datadata', e.detail.richText)
                setNote(e.detail.richText || '')
              },

              focusfunc: () => {
                // setTypingNote(true)
                typingNote.current = true
              },
              blurfunc: () => {
                // setTypingNote(false)
                typingNote.current = false
                // if (!note) {
                //   setNote(todo?.note || '')
                //   return
                // }
              },
              submit: () => {},
            },
            (e: any) => {
              richtextEl.current = e
              richtextEl.current?.setToolbar?.({
                container: [],
              })
            }
          )}
          theme="snow"
          toolbar="false"
          editor-padding="0px"
          toolbar-padding="0px"
          // max-height='250px'
          min-height="120px"
          width="100%"
          padding="0"
          font-size="14px"
          border-radius="0"
          min-length="0"
          max-length="10000"
          clear-all-styles-when-pasting
          short-enter="NewLine"
          background-color="rgb(243,243,243)"
          value={note}
          placeholder={t('typeANote', {
            ns: 'todoPage',
          })}
        />
      </div>
    </div>
  )
}

const MoveTaskToPage = ({
  contentResult,
  todo,
}: {
  contentResult: ContentResult
  todo: protoRoot.note.ITodoListPageItem
}) => {
  const { t, i18n } = useTranslation('todoPage')

  const d = useRef(new Debounce())
  const dispatch = useDispatch<AppDispatch>()

  const notes = useSelector((state: RootState) => state.notes)
  const config = useSelector((state: RootState) => state.config)
  const autoCloseWindowAfterCopy = useSelector(
    (state: RootState) => state.config.general.autoCloseWindowAfterCopy
  )

  const asideContentModal = useSelector(
    (state: RootState) => state.config.pageConfig.asideContentModal
  )

  let history = useNavigate()
  const ref = useRef<any>(null)

  const richtextEl = useRef<any>()

  const [todolist, setTodolist] = useState([] as typeof contentResult.todoList)
  const [parentTodolist, setParentTodolist] = useState<
    protoRoot.note.ITodoListPageItem[]
  >([])
  const [selectParentId, setSelectParentId] = useState<string>(
    todo.parentId || ''
  )

  useEffect(() => {
    setSelectParentId(todo.parentId || '')
  }, [asideContentModal.visible])

  useEffect(() => {
    setTodolist(
      contentResult.todoList?.filter(
        (v) =>
          v.parentId === (parentTodolist[parentTodolist.length - 1]?.id || '')
      )
    )
  }, [todo, parentTodolist.length, asideContentModal.visible])

  const comfirm = () => {
    dispatch(
      notesSlice.actions.updateTodo({
        noteId: contentResult.note?.id || '',
        categoryId: contentResult.category?.id || '',
        pageId: contentResult.page?.id || '',
        todoId: todo.id || '',
        data: {
          parentId: selectParentId === 'topLevel' ? '' : selectParentId,
        },
      })
    )
    dispatch(
      configSlice.actions.setShowAsideContentModal({
        visible: false,
      })
    )
  }

  return (
    <div className="move-task-to-page">
      <div className="mtt-title">
        <div className="mtt-t-left">
          {parentTodolist?.length > 0 ? (
            <SakiButton
              onTap={() => {
                setParentTodolist(
                  parentTodolist.slice(0, parentTodolist.length - 1)
                )
              }}
              margin="0 4px 0 -10px"
              type="CircleIconGrayHover"
            >
              <SakiIcon type="ArrowLeft"></SakiIcon>
            </SakiButton>
          ) : (
            ''
          )}
          {parentTodolist.length ? (
            <SakiBreadcrumb
              options={parentTodolist.map((v, i) => {
                return {
                  value: v.id || '',
                  text: v.title || '',
                }
              })}
            ></SakiBreadcrumb>
          ) : (
            <SakiTitle color="#666" fontWeight="500" level={4}>
              {t('moveTaskTo')}
            </SakiTitle>
          )}
        </div>
        <div className="mtt-t-right">
          <SakiButton
            onTap={() => {
              comfirm()
            }}
            border="none"
            type="Primary"
            // disabled={selectParentId === todo.parentId}
          >
            <span>
              {t('confirm', {
                ns: 'sakiuiPrompt',
              })}
            </span>
          </SakiButton>
        </div>
      </div>

      <div className="mtt-list scrollBarHover">
        <SakiCheckbox
          onSelectvalue={(e) => {
            setSelectParentId(e.detail.value)
          }}
          value={selectParentId}
          flex-direction="Column"
          type="Radio"
        >
          {parentTodolist?.length === 0 ? (
            <div className="mtt-l-item">
              <SakiCheckboxItem margin="14px 8px 14px 0" value={'topLevel'}>
                <span>{t('moveToTopLevel')}</span>
              </SakiCheckboxItem>
            </div>
          ) : (
            ''
          )}
          {todolist?.map((v) => {
            const subCount = getSubTodoCount(
              contentResult.todoList || [],
              v?.id || '',
              [1, 0]
            )
            return (
              <div className="mtt-l-item">
                <SakiCheckboxItem
                  key={v.id}
                  margin="14px 8px 14px 0"
                  value={v.id || ''}
                  disabled={v.id === todo.id}
                >
                  <SakiRow alignItems="center">
                    <span
                      style={{
                        flex: 1,
                      }}
                      className="text-elipsis"
                    >
                      {v.title}
                    </span>
                    <span
                      style={{
                        color: '#999',
                        fontSize: '11px',
                        padding: '0 10px',
                      }}
                      className=""
                    >
                      {v.id}
                    </span>
                  </SakiRow>
                </SakiCheckboxItem>
                <SakiButton
                  onTap={() => {
                    setParentTodolist(parentTodolist.concat([v]))
                  }}
                  type="CircleIconGrayHover"
                  disabled={subCount === 0}
                >
                  <SakiIcon
                    color={subCount === 0 ? '#ccc' : '#777'}
                    type="ArrowRight"
                  ></SakiIcon>
                </SakiButton>
              </div>
            )
          })}
        </SakiCheckbox>
      </div>
    </div>
  )
}

export const LabelItem = ({
  style,
  label,
}: {
  style?: CSSProperties
  label: protoRoot.note.PageItem.ILabelItem
}) => {
  return (
    <div
      style={
        {
          ...style,
          // '--color': label.color ? '#fff' : '#444',
          // '--bg-color': label.color ? label.color  : '',
          '--color': label.color ? label.color : '#222',
          '--border-color': label.color ? label.color : '#222',
          '--bg-color': label.color ? label.color + '22' : '',
        } as any
      }
      className="label-item-component"
    >
      <span>{label.name}</span>
    </div>
  )
}

const SetLabelsPage = ({ contentResult }: { contentResult: ContentResult }) => {
  const { t } = useTranslation('todoPage')

  const dispatch = useDispatch<AppDispatch>()

  const asideContentModal = useSelector(
    (state: RootState) => state.config.pageConfig.asideContentModal
  )

  const [labels, setLabels] = useState<protoRoot.note.PageItem.ILabelItem[]>([])
  const [isChanged, setIsChanged] = useState(false)
  const [showColorDPId, setShowColorDPId] = useState('')
  const [showSettingDPId, setShowSettingDPId] = useState('')
  const [showStatusDPId, setShowStatusDPId] = useState('')
  const time = useRef(0)

  useEffect(() => {
    if (
      asideContentModal.visible &&
      asideContentModal.data?.type === 'SetLabels'
    ) {
      setLabels(contentResult.page?.labels || getDefaultLabels())
      time.current = new Date().getTime()
    }

    return () => {
      // console.log('SetLabels asideContentModal', asideContentModal.visible)

      // if (!asideContentModal.visible) {
      setLabels([])
      setIsChanged(false)
      setShowColorDPId('')
      setShowSettingDPId('')
      setShowStatusDPId('')
      time.current = 0
      eventListener.dispatch('confirmButtonDisabled', true)
      // }
    }
  }, [
    asideContentModal.visible,
    asideContentModal.data?.type,
    contentResult,
    t,
  ])

  useEffect(() => {
    // console.log('SetLabels labels', isChanged, labels)
    if (isChanged) {
      eventListener.dispatch('confirmButtonDisabled', false)
      eventListener.on('saveButtonClick', () => {
        console.log('SetLabels saveButtonClick', labels)
        const { noteId, categoryId, pageId } = asideContentModal.data

        dispatch(
          notesSlice.actions.updatePage({
            noteId,
            categoryId,
            pageId,
            data: {
              labels: labels?.filter((v) => v.name),
            },
          })
        )
        dispatch(
          configSlice.actions.setShowAsideContentModal({
            visible: false,
          })
        )
      })
    } else {
      if (new Date().getTime() - time.current > 300) {
        setIsChanged(true)
      }
    }
    return () => {
      eventListener.removeEvent('saveButtonClick')
    }
  }, [isChanged, labels])

  return (
    <div className="set-labels-page">
      <div className="sl-list scrollBarHover">
        {/* <div className="sil-item title">
          <div className="sili-label">演示</div>
          <div className="sili-name">标签名</div>
          <div className="sili-color">颜色</div>
          <div className="sili-status">状态</div>
          <div className="sili-more">操作</div>
        </div> */}
        {labels?.map((v, i) => {
          return (
            <div key={v.id} className="sil-item">
              <div className="sili-label">
                {v.name ? (
                  <LabelItem
                    style={{
                      margin: '0 6px 0 0',
                    }}
                    label={v}
                  />
                ) : (
                  ''
                )}
              </div>
              <div className="sili-name">
                <SakiInput
                  onChangevalue={(e) => {
                    setLabels(
                      labels.map((sv) => {
                        return {
                          ...sv,
                          name: sv.id === v.id ? e.detail : sv.name,
                        }
                      })
                    )
                  }}
                  border={`1px solid ${'#ddd'}`}
                  // border={`1px solid ${v.bindStatus === 1 ? 'var(--saki-default-color)' : '#ddd'}`}
                  height="36px"
                  borderRadius="10px"
                  padding="0 10px"
                  value={v.name || ''}
                ></SakiInput>
              </div>
              <div className="sili-color">
                <saki-dropdown
                  visible={showColorDPId === v.id}
                  floating-direction="Left"
                  ref={bindEvent({
                    close: () => {
                      setShowColorDPId('')
                    },
                  })}
                >
                  <saki-button
                    ref={bindEvent({
                      tap: () => {
                        setShowColorDPId(v.id || '')
                      },
                    })}
                    margin="0 0 0 4px"
                    width="30px"
                    height="30px"
                    bg-color="transparent"
                    bg-hover-color={'#ddd'}
                    bg-active-color={'#ccc'}
                    type="CircleIconGrayHover"
                  >
                    <div
                      style={
                        {
                          '--color': v.color || '#999999',
                        } as any
                      }
                      className="set-label-color"
                    ></div>
                  </saki-button>

                  <div slot="main">
                    <saki-menu
                      ref={bindEvent({
                        selectvalue: async (e) => {
                          // console.log(e.detail.value)

                          setLabels(
                            labels.map((sv) => {
                              return {
                                ...sv,
                                color:
                                  sv.id === v.id
                                    ? e.detail.value === '#999999'
                                      ? ''
                                      : e.detail.value
                                    : sv.color,
                              }
                            })
                          )

                          setShowColorDPId('')
                        },
                      })}
                    >
                      {[
                        '#0969da', // 蓝
                        '#9a6700', // 橙/金
                        '#1a7f37', // 绿
                        '#cf222e', // 红
                        '#8250df', // 紫
                        '#bf3989', // 粉
                        '#bc4e00', // 棕
                        '#006d77', // 青
                        '#2e3c50', // 深蓝/黑
                        '#999999',
                      ].map((v, i) => {
                        return (
                          <saki-menu-item font-size="14px" value={v} key={i}>
                            <div
                              style={
                                {
                                  '--color': v,
                                } as any
                              }
                              className="set-label-color"
                            ></div>
                          </saki-menu-item>
                        )
                      })}
                    </saki-menu>
                  </div>
                </saki-dropdown>
              </div>
              <div className="sili-status">
                <saki-dropdown
                  visible={showStatusDPId === v.id}
                  floating-direction="Left"
                  ref={bindEvent({
                    close: () => {
                      setShowStatusDPId('')
                    },
                  })}
                >
                  <saki-button
                    ref={bindEvent({
                      tap: () => {
                        setShowStatusDPId(v.id || '')
                      },
                    })}
                    // margin="0 -2px 0 4px"
                    // border={`1px solid ${v.bindStatus === 1 ? 'var(--saki-default-color)' : 'transparent'}`}
                    type={'Normal'}
                  >
                    <span
                      style={{
                        fontSize: '12px',
                        color:
                          v.bindStatus === 1 ? 'var(--saki-default-color)' : '',
                      }}
                    >
                      {v.bindStatus
                        ? t('markedAs', {
                            ns: 'todoPage',
                            status: t(v.bindStatus === 1 ? 'complete' : '', {
                              ns: 'todoPage',
                            }),
                          })
                        : t('bindStatus')}
                    </span>
                  </saki-button>

                  <div slot="main">
                    <saki-menu
                      ref={bindEvent({
                        selectvalue: async (e) => {
                          setLabels(
                            labels.map((sv) => {
                              return {
                                ...sv,
                                bindStatus:
                                  sv.id === v.id
                                    ? e.detail.value === 'Completed'
                                      ? 1
                                      : 0
                                    : 0,
                              }
                            })
                          )

                          setShowStatusDPId('')
                        },
                      })}
                    >
                      {[
                        {
                          value: 'Completed',
                          text: t('markAs', {
                            ns: 'todoPage',
                            status: t('complete', {
                              ns: 'todoPage',
                            }),
                          }),
                        },
                        {
                          value: 'CancelBind',
                          text: t('cancelBind', {
                            ns: 'todoPage',
                          }),
                        },
                      ].map((v, i) => {
                        return (
                          <SakiMenuItem
                            font-size="14px"
                            value={v.value}
                            padding="10px 16px"
                            key={i}
                          >
                            <span>{v.text}</span>
                          </SakiMenuItem>
                        )
                      })}
                    </saki-menu>
                  </div>
                </saki-dropdown>
              </div>
              <div className="sili-more">
                <saki-dropdown
                  visible={showSettingDPId === v.id}
                  floating-direction="Left"
                  ref={bindEvent({
                    close: () => {
                      setShowSettingDPId('')
                    },
                  })}
                >
                  <saki-button
                    ref={bindEvent({
                      tap: () => {
                        setShowSettingDPId(v.id || '')
                      },
                    })}
                    margin="0 -2px 0 4px"
                    width="30px"
                    height="30px"
                    type="CircleIconGrayHover"
                  >
                    <saki-icon
                      width="14px"
                      height="14px"
                      color="#666"
                      type={'Settings'}
                    ></saki-icon>
                  </saki-button>

                  <div slot="main">
                    <saki-menu
                      ref={bindEvent({
                        selectvalue: async (e) => {
                          setShowSettingDPId('')
                          setTimeout(() => {
                            if (e.detail.value === 'Delete') {
                              setLabels(labels.filter((sv) => sv.id !== v.id))

                              return
                            }

                            const tempLabels = deepCopy(labels)
                            // 1. 找到当前操作的元素
                            const targetIndex = i // 或者 tempLabels.findIndex(sv => sv.id === v.id)
                            const [targetItem] = tempLabels.splice(
                              targetIndex,
                              1
                            )

                            switch (e.detail.value) {
                              case 'MoveToTop':
                                // 2. 插入到数组开头
                                tempLabels.unshift(targetItem)
                                break
                              case 'MoveToBottom':
                                // 2. 插入到数组末尾
                                tempLabels.push(targetItem)
                                break
                              default:
                                return // 无操作直接返回
                            }

                            // 3. 统一重置所有元素的 sort 值（1, 2, 3...）
                            // 这样可以确保 sort 永远是连续且唯一的
                            tempLabels.forEach((item, index) => {
                              item.sort = index + 1
                            })

                            // 4. 更新状态
                            setLabels([...tempLabels])
                          })
                        },
                      })}
                    >
                      {[
                        {
                          value: 'MoveToTop',
                          text: t('moveToTop', {
                            ns: 'sakiuiPrompt',
                          }),
                        },
                        {
                          value: 'MoveToBottom',
                          text: t('moveToBottom', {
                            ns: 'sakiuiPrompt',
                          }),
                        },
                        {
                          value: 'Delete',
                          text: t('delete', {
                            ns: 'common',
                          }),
                        },
                      ].map((v, i) => {
                        return (
                          <SakiMenuItem
                            font-size="14px"
                            value={v.value}
                            padding="10px 16px"
                            key={i}
                          >
                            <span>{v.text}</span>
                          </SakiMenuItem>
                        )
                      })}
                    </saki-menu>
                  </div>
                </saki-dropdown>
              </div>
            </div>
          )
        })}

        <div className="sll-buttons">
          <SakiButton
            onTap={() => {
              setLabels(
                labels.concat({
                  id: getShortId(13),
                  name: '',
                  sort: labels.length,
                })
              )
            }}
            width="100px"
            height="36px"
            borderRadius="10px"
            margin="0 0 10px 0"
            type={'Primary'}
          >
            <span>
              {t('add', {
                ns: 'common',
              })}
            </span>
          </SakiButton>
        </div>
      </div>
    </div>
  )
}

export default AsideContentComponent
